module.exports = __webpack_public_path__ + "img/b1.b7ef5fae.png";